<template>
  <div class="login-container">
    <div class="login-card">
      <h2>植物科普后台管理系统</h2>

      <!-- 账号输入框 -->
      <input
          v-model="username"
          type="text"
          placeholder="请输入用户名"
          class="login-input"
      />

      <!-- 密码输入框 -->
      <input
          v-model="password"
          type="password"
          placeholder="请输入密码"
          class="login-input"
      />

      <!-- 登录按钮 -->
      <button @click="login" class="login-button">登录</button>

      <!-- 错误提示 -->
      <p v-if="error" class="error-message">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from '@/services/api';

export default {
  name: "LoginPage",
  data() {
    return {
      username: "", // 用户名
      password: "", // 密码
      error: "", // 错误信息提示
    };
  },
  methods: {
    async login() {
      this.error = "";

      // 简单的表单校验
      if (!this.username || !this.password) {
        this.error = "请输入用户名和密码";
        return;
      }

      try {
        // 向后端发起登录请求
        const response = await api.post("/login", {
          username: this.username,
          password: this.password,
        });

        // 假设后端返回格式 { token: "...", code: 0 }
        if (response.data.token) {
          // 把 token 存到浏览器本地存储
          localStorage.setItem("token", response.data.token);

          // 登录成功后跳转到首页
          this.$router.push("/index");
        } else {
          this.error = "登录失败，请检查用户名或密码";
        }
      } catch (err) {
        console.error(err);
        this.error = "登录请求出错，请稍后再试";
      }
    },
  },
};
</script>

<style scoped>
/* 登录页整体布局 */
.login-container {
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(120deg, #a8edea, #fed6e3);
}

/* 登录卡片样式 */
.login-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

/* 输入框样式 */
.login-input {
  display: block;
  width: 100%;
  margin: 12px 0;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

/* 登录按钮样式 */
.login-button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 8px;
  background-color: #66bb6a;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.login-button:hover {
  background-color: #57a05a;
}

/* 错误提示 */
.error-message {
  color: red;
  margin-top: 10px;
}
</style>
